import { gql } from '@apollo/client';
import { EsSyncTaskResult } from './syncEsByTimeRange';

export interface SyncEsByIdsOrTrackingNumbersResponse {
    syncEsByIdsOrTrackingNumbers: EsSyncTaskResult;
}

export interface SyncEsByIdsOrTrackingNumbersVariables {
    input: {
        orderIds?: number[];
        trackingNumbers?: string[];
    };
}

export const SYNC_ES_BY_IDS_OR_TRACKING_NUMBERS = gql`
    mutation SyncEsByIdsOrTrackingNumbers($input: SyncEsByIdsInput!) {
        syncEsByIdsOrTrackingNumbers(input: $input) {
            taskId
            estimatedOrderCount
            description
        }
    }
`;
